/**
 * @name 公共接口
 */

import { baseURL } from '@/api/base' // 导入接口域名列表
import axios from '@/utils/http' // 导入http中创建的axios实例
import type { UserInfo } from '@/api/modules/systemManage/user'
import type { DictData, DictType2dicts } from '@shared/dict'

//* 获取登录用户的详情
export const getLoginUserDetail: () => Promise<UserInfo> = () => axios.get(`${baseURL}/api/sysUser/getLoginUserDetail`)

//* 获取字典
export const getAllDictList: () => Promise<DictType2dicts> = () => axios.get(`${baseURL}/api/sysDict/getAllDictList`)

//* 获取地区列表，不传值默认取国家列表
export type Area = {
	areaCode: string // 地区编码
	areaId: IdType // 地区id
	areaLevel: number // 地区级别
	areaName: string // 地区名称
	areaType: string // 地区类型
	createTime: string // 创建时间
	parentId: IdType
	sortNo: number
	leaf?: boolean // 是否叶子节点
}
export const LEAF_AREA_CODE = 'C'
export const areaProps: DefaultProps = {
	value: 'areaId',
	label: 'areaName',
}
export const listArea: (parentId: Area['parentId']) => Promise<Area[]> = parentId => axios.get(`${baseURL}/api/sysArea/listArea?parentId=${parentId}`, { hideLoading: true })

//* 通过字典类型获取所有字典值
export const getByDictData: (dictType: DictData['dictType']) => Promise<DictData[]> = () => axios.get(`${baseURL}/api/v1/common/getByDictData`, { hideLoading: true })

// * /api/v1/common/checkIfExistsValue 检查是否存在相同的值
export type CheckIfExistsValueParam = { columnName: string; tableName: string; value: unknown }
export const checkIfExistsValue: (params: CheckIfExistsValueParam) => Promise<{ result: boolean }> = (params: CheckIfExistsValueParam) =>
	axios.post(`${baseURL}/api/v1/common/checkIfExistsValue`, JSON.stringify(params), { hideLoading: true })

export default {
	getLoginUserDetail,
	getAllDictList,
	listArea,
	getByDictData,
	checkIfExistsValue,
}
